var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 items-center content-center flex flex-col",
      staticStyle: { width: "6.875rem" },
    },
    [_c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.name))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }